import React from 'react';
import { Box, Typography } from '@mui/material';
import { SxProps } from '@mui/material';

export function InfoPanel({
  text,
  title,
  sx,
}: {
  title: string;
  text: string;
  sx?: SxProps;
}) {
  return (
    <Box sx={{ p: 3, backgroundColor: '#F0F7FA', borderRadius: '16px', ...sx }}>
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mb: 1 }}>
        <img src={'assets/img/question.svg'} width={24} height={24} />
        <Typography className={'fs-16 lh-24 bold'}>{title}</Typography>
      </Box>
      <Typography sx={{ color: '#4D4D4D' }} className={'fs-16 lh-24'}>
        {text}
      </Typography>
    </Box>
  );
}
